import { BreakpointMap, Breakpoints } from './types';

export const BREAKPOINTS: BreakpointMap<Breakpoints> = {
    MOBILE_S: 320,
    MOBILE_M: 375,
    MOBILE_L: 540,
    MOBILE_XL: 768,
    DESKTOP_S: 1024,
    DESKTOP_M: 1280,
    DESKTOP_L: 1440,
};
